export const publicHolidayList = [
  {
    id: 1,
    holiday: 'Republic Day',
    date: new Date ('2025-01-26T00:00:00+05:30'),
  },
  {
    id: 2,
    holiday: 'Maha Shivaratri',
    date: new Date ('2025-02-26T00:00:00+05:30'),
  },
  {
    id: 3,
    holiday: 'Holi',
    date: new Date ('2025-03-14T00:00:00+05:30'),
  },
  {
    id: 4,
    holiday: 'Id-ul-Fitr',
    date: new Date ('2025-03-31T00:00:00+05:30'),
  },
  {
    id: 5,
    holiday: 'Mahavir Jayanti',
    date: new Date ('2025-04-10T00:00:00+05:30'),
  },
  {
    id: 6,
    holiday: 'Good Friday',
    date: new Date ('2025-04-18T00:00:00+05:30'),
  },
  {
    id: 7,
    holiday: 'Buddha Purnima',
    date: new Date ('2025-05-12T00:00:00+05:30'),
  },
  {
    id: 8,
    holiday: 'Id-ul-Zuha (Bakrid)',
    date: new Date ('2025-06-07T00:00:00+05:30'),
  },
  {
    id: 9,
    holiday: 'Muharram',
    date: new Date ('2025-07-06T00:00:00+05:30'),
  },
  {
    id: 10,
    holiday: 'Independence Day',
    date: new Date ('2025-08-15T00:00:00+05:30'),
  },
  {
    id: 11,
    holiday: 'Janmashtami',
    date: new Date ('2025-08-16T00:00:00+05:30'),
  },
  {
    id: 12,
    holiday: 'Milad-un-Nabi (Id-e-Milad)',
    date: new Date ('2025-09-05T00:00:00+05:30'),
  },
  {
    id: 13,
    holiday: 'Mahatma Gandhi’s Birthday',
    date: new Date ('2025-10-02T00:00:00+05:30'),
  },
  {
    id: 14,
    holiday: 'Dussehra',
    date: new Date ('2025-10-02T00:00:00+05:30'),
  },
  {
    id: 15,
    holiday: 'Diwali (Deepavali)',
    date: new Date ('2025-10-20T00:00:00+05:30'),
  },
  {
    id: 16,
    holiday: 'Guru Nanak’s Birthday',
    date: new Date ('2025-11-05T00:00:00+05:30'),
  },
  {
    id: 17,
    holiday: 'Christmas Day',
    date: new Date ('2025-12-25T00:00:00+05:30'),
  },
  {
    id: 18,
    holiday: 'June Random Wednesday Holiday',
    date: new Date ('2025-06-11T00:00:00+05:30'),
  },
];
